import Progress from 'redux-progress';

import type { MACDownloadsAction, MACDownloadsState } from '../models';
import {
  FETCH_HAS_SOURCE_DOWNLOADS,
  FETCH_PRODUCT_SOURCE_DOWNLOAD,
  FETCH_SOURCE_DOWNLOAD_URL,
} from '../actions/downloads';

export const initialState = {
  hasSourceDownloads: Progress.none,
  productSourceDownload: Progress.none,
};

export default (
  state: MACDownloadsState = initialState,
  action: MACDownloadsAction,
): MACDownloadsState => {
  switch (action.type) {
    case FETCH_HAS_SOURCE_DOWNLOADS:
      return {
        ...state,
        hasSourceDownloads: {
          ...state.hasSourceDownloads,
          [action.product]: action.progress,
        },
      };

    case FETCH_PRODUCT_SOURCE_DOWNLOAD:
      return {
        ...state,
        productSourceDownload: action.progress,
      };

    case FETCH_SOURCE_DOWNLOAD_URL:
      return {
        ...state,
        sourceDownloadURL: action.progress,
      };
    default:
      return state;
  }
};
